import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {ClassroomEditStore} from './ClassroomEditStore';

@observer
export class ClassroomEditControls extends React.Component<{ store: ClassroomEditStore }> {
  render() {
    const store = this.props.store;
    const isLoading = store.save?.isPending === true;
    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.parent.completeEdit}
                  disabled={isLoading}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.parent.cancel}
                  disabled={isLoading}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Updating" state={store.save} align="right"/>
    </>);
  }
}
